<template>
  <v-app>
    <v-app-bar app height="48" color="blue darken-2'" dark>
      <div class="d-flex align-center">
        <v-img src="@/assets/still-small.png" height="30" width="20" contain/>
        <div class="text-h6 ml-3 mt-1">PURTRAK</div>
      </div>
      <v-spacer/>
      <v-btn text @click="$auth.logout();$store.commit('clearUser');$auth.login()">Sign out</v-btn>
    </v-app-bar>

    <v-main>
      <v-container fluid fill-height>
        <v-row justify="center">
          <v-card width="380" class="d-inline-block text-center pa-1" flat>

            <v-card flat class="text-h5 text-center" v-if="error">
              {{error}}
            </v-card>

            <v-card v-else-if="create" :flat="$vuetify.breakpoint.mobile" class="text-left">
              <v-form ref="form">
                <v-container class="pa-4">
                  <v-row>
                    <v-col class="text-h5">Create distillery</v-col>
                  </v-row>
                  <v-row>
                    <v-col class="text-body-1">One more step...we need to create a distillery for you</v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field label="Distillery name" v-model="name" outlined dense counter="50" :rules="[fieldRules.required]" autofocus/>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="4">
                      <v-autocomplete label="Province" v-model="province" outlined dense shide-details :items="['AB','BC','MB','NB','NL','NS','NT','NU','ON','PE','QC','SK','YT']"/>
                    </v-col>
                    <v-col offset="1" class="text-caption pt-3">
                      We need to know how to set up taxes
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="6">
                      <v-combobox label="Plan" v-model="plan" outlined dense persistent-hint :items="['Essentials','Plus']"
                                  hint="You can change your plan at any time"/>
                    </v-col>
                    <v-col class="ml-6">
                      {{planAmount}} / month<br/><strong class="green--text">30 DAY FREE TRIAL</strong>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="6">
                      <v-text-field label="Referral code" v-model="referralcode" outlined dense :rules="[fieldRules.maxLength(10)]"
                                     hint="Only if you were given one"/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn color="primary" large width="100%" @click="save" :loading="saving">Create Distillery</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card>

            <v-card v-else flat class="text-center">
              <v-progress-circular color="primary" indeterminate size="100"/>
            </v-card>

          </v-card>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      error: '',
      create: false,
      name: '',
      province: 'ON',
      plan: 'Plus',
      saving: false,
      referralcode: ''
    }
  },
  computed: {
    planAmount() {
      return {Essentials:'$150.00',Plus:'$200.00',Premium:'$250.00'}[this.plan];
    },
    user() {
      return this.$store.state.user ?? {};
    },
  },
  async created() {
    this.error = this.$route.query.error_message;

    const sessionState = sessionStorage.getItem('oauthState');
    sessionStorage.removeItem('oauthState');
    if (!this.error && this.$route.query.state !== sessionState) {
      // It's more than likely that if we got here it's because of a direct link to login
      // Just go to the dashboard and if we aren't logged in it will take us to oauth,
      // otherwise it's business as usual
      console.log('State mismatch');
      this.$router.replace({name:'Dashboard'});
//      this.error = 'State mismatch';
    }
    else {
      await this.$auth.getToken(this.$route.query.code);
      this.$store.commit('setUser', null);
      this.$store.commit('setCompanies', []);
      try {
        await this.$router.replace({name:'Dashboard'});
      } catch (error) {
        // No company found for user, so get her to create one
        this.referralcode = sessionStorage.getItem('referralcode') ?? '';
        this.create = true;
      }
    }
  },
  methods: {
    async save() {
      if (!this.$refs.form.validate())
        return;
      this.saving = true;
      const results = await this.$apiCall(`mutation LoginCreateCompany($input: CompanyCreateInput!) {
                                            companyCreate(input:$input) {id,name}
                                          }`,
                                          {input:{name:this.name,email:this.$store.state.user.email,homeCurrency:'CAD',province:this.province,plan:this.plan,referralcode:this.referralcode}});
      this.saving = false;
      if (!results.error) {
        sessionStorage.removeItem('referralcode');
        this.$store.commit('clearUser');    // Need to force router to reload company info
        this.$router.replace({name:'Dashboard'});
      }
    }
  }
}
</script>
